import KeyHandler from "@/classes/KeyHandler";

const keyHandler = new KeyHandler();

export default {
	data() {
		return {
			watchedKeyHandlers: {},
		};
	},
	computed: {
		keyHandler() {
			return keyHandler;
		},
	},
	methods: {
		watchKey(key, method) {
			this.keyHandler.watchKey(key, method, this);
		},
		unwatchKey(key) {
			this.keyHandler.unwatchKey(key, this);
		},
		unwatchKeys(keys = null) {
			this.keyHandler.unwatchKeys(keys, this);
		},
	},
	beforeDestroy() {
		this.unwatchKeys();
	},
};
